export default __webpack_public_path__ + "static/media/ichoice_10.fd938275.jpg";